export default "__VITE_ASSET__fuKqv4So__"